import React from "react";
import Container from "../../components/misc/Container";
import { Link } from "react-router-dom";
import LayoutHomepage from "../../layout/LayoutHomepage";

import BawahPutih from "../../assets/images/resep/tumis-tahu/BAWANGPUTIH.jpeg";
import BawangMerah from "../../assets/images/resep/tumis-tahu/BAWANGMERAH.jpeg";
import Jahe from "../../assets/images/resep/soto/JAHE.png";
import JamurTiram from "../../assets/images/resep/tumis-tahu/JamurTiram.jpeg";
import Kailan from "../../assets/images/resep/tumis-tahu/Kailan.jpeg";
import Tahu from "../../assets/images/resep/tumis-tahu/TAHU.jpeg";
import Lombok from "../../assets/images/resep/tumis-tahu/CABAIRAWIT.jpeg";

import Tumis from "../../assets/images/resep/tumis.svg";


// Import Icon
import { ReactComponent as ClockIcon } from "../../assets/icons/icon-ios-timer.svg";
import { ReactComponent as ForkIcon } from "../../assets/icons/icon-fork-eat.svg";
import DynamicScrollToTop from "../../components/misc/DynamicScrollToTop";
import classnames from "classnames";

const TumisTahu = () => {

    let recipe = {
        recipeTitle : "Tumis Tahu Hijau",
        recipeHour : "1",
        recipePortion : "4",
        status : "Sedang",
        imgSrc : Tumis
    }

    let igredients = [
        {
            imgSrc : Lombok,
            imgAlt : "",
            title : "Ayam Paha",
            weight : "250gr",
            price : "Rp8000",
            discountPrice : "",
        },
        {
            imgSrc : BawahPutih,
            imgAlt : "",
            title : "Bawang Putih",
            weight : "250gr",
            price : "Rp7500",
            discountPrice : "",
        },
        {
            imgSrc : Jahe,
            imgAlt : "",
            title : "Jahe keraton",
            weight : "250gr",
            price : "Rp6500",
            discountPrice : "",
        },
        {
            imgSrc : JamurTiram,
            imgAlt : "",
            title : "Jamur Tiram",
            weight : "250gr",
            price : "Rp7000",
            discountPrice : "",
        },
        {
            imgSrc : Tahu,
            imgAlt : "",
            title : "Tahu",
            weight : "250gr",
            price : "Rp3500",
            discountPrice : "",
        },
        {
            imgSrc : BawangMerah,
            imgAlt : "",
            title : "Bawang Merah",
            weight : "250gr",
            price : "Rp3500",
            discountPrice : "",
        },
        {
            imgSrc : Kailan,
            imgAlt : "",
            title : "Kailan",
            weight : "250gr",
            price : "Rp3500",
            discountPrice : "",
        }
    ]

  return (
    <>
      <DynamicScrollToTop />
      <LayoutHomepage>
        <div className="flex flex-col w-full mt-32">
          <Container>
            <div className="flex flex-col w-full mr-2">
              <div className="flex w-full mb-2 mt-8">
                <p className="flex items-center text-font-gray opacity-50">
                  <Link to="/homepage">Beranda </Link>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 opacity-100 mx-2"
                    viewBox="0 0 11.384 20.025"
                  >
                    <g
                      id="Group_4034"
                      data-name="Group 4034"
                      transform="translate(1.414 1.414)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="12.099"
                        transform="translate(8.555 8.642) rotate(135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="12.099"
                        transform="translate(8.555 8.555) rotate(-135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                  <Link to="/recipe">Resep</Link>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 opacity-100 mx-2"
                    viewBox="0 0 11.384 20.025"
                  >
                    <g
                      id="Group_4034"
                      data-name="Group 4034"
                      transform="translate(1.414 1.414)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="12.099"
                        transform="translate(8.555 8.642) rotate(135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="12.099"
                        transform="translate(8.555 8.555) rotate(-135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                </p>
                <p className="flex items-center text-font-gray">
                  {recipe.recipeTitle}
                </p>
              </div>
              <div className="flex">
                <div className="flex">
                  <div className="border rounded-md bg-white mb-8 mr-8 mt-8">
                    <img alt={recipe.recipeTitle} className="m-4 rounded-md" src={recipe.imgSrc} />
                  </div>
                </div>
                <div className="flex-grow rounded overflow-hidden shadow-lg flex flex-col justify-center items-center pl-12">
                  <div className="flex justify-start flex-col w-full">
                    <h1 className="text-3xl font-bold text-left">
                      {recipe.recipeTitle}
                    </h1>
                    <div className="bg-white rounded-lg flex justify-center align-center mt-4 w-9/12 shadow-sm">
                      <div className="px-6 py-3 flex items-center w-full">
                        <div className="flex items-center">
                          <ClockIcon className="w-4 h-4 mr-2" />
                          <p className="font-semibold">{recipe.recipeHour} Jam</p>
                        </div>

                        <div className="flex items-center mx-auto">
                          <ForkIcon className="w-4 h-4 mr-2" />
                          <p className="font-semibold">{recipe.recipePortion} Porsi</p>
                        </div>
                        <span className={classnames("font-semibold",{ "text-green-100 bg-greenlight-100 border border-green-100 px-4 py-1" : recipe.status === "Mudah",
                        "text-basic-orange bg-orange-100 border border-basic-orange px-4 py-1" : recipe.status === "Sedang",
                        "text-red-600 bg-red-100 border border-red-600 px-4 py-1" : recipe.status === "Sulit",
                    }, "rounded-md")}>
                        {recipe.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h1 className="text-2xl semi-bold mt-4 mb-2">Bahan Baku</h1>
              <div className="flex">
                <div className="flex flex-wrap w-full -mx-2">
                  {/* Items  */}

                  {igredients.map((item, index) => (
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={item.imgSrc} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">{item.title}</p>
                        <p className="text-font-gray-text text-xs">{item.weight}</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        <br/>
                      </p>
                      <p className="text-gray-600 ">{item.price}</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  ))}

                  {/* End Items  */}
                </div>
              </div>
              <h1 className="text-2xl font-semibold mb-2 mt-4">Bahan Bahan</h1>
              <div className="flex w-full">
                <div className="flex-wrap mr-10 mb-10 ">
                  <div className="bg-white p-10">
                    <div className="flex p-1">
                      <h3 className="font-bold">Bahan</h3>
                    </div>
                    <div className="flex mt-8">
                      <div className="flex-wrap mr-4 font-bold">350g</div>
                      <div className="flex-wrap">Tahu putih, potong dadu 2 cm</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">200g</div>
                      <div className="flex-wrap">Kailan, potong-potong</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">100g</div>
                      <div className="flex-wrap">Jamur tiram</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">150g</div>
                      <div className="flex-wrap">Ercis</div>
                    </div>
                  </div>
                  <div className="bg-white p-10 ">
                    <div className="flex p-1">
                      <h3 className="font-bold">Bumbu marinasi</h3>
                    </div>
                    <div className="flex mt-8">
                      <div className="flex-wrap mr-4 font-bold">150g</div>
                      <div className="flex-wrap">Cabai rawit haluskan</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">2c100gm</div>
                      <div className="flex-wrap">Bawang putih haluskan</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">50 ml</div>
                      <div className="flex-wrap">Minyak goreng secukupnya</div>
                    </div>
                  </div>
                  
                </div>
                <div className="flex-wrap w-8/12 ">
                  <div className="flex flex-col bg-white rounded">
                    <div className="p-4">
                      <h1 className="font-bold text-xl text-basic-orange text-center">
                        Cara membuat
                      </h1>
                      <ul className="mt-4">
                        <li className="m-8">
                          1. Di dalam mangkuk, campurkan tahu yang telah dipotong bersama bumbu marinasi. Aduk rata dan diamkan selama 10 menit. Sisihkan bumbu marinasi.
                        </li>
                        <li className="m-8">
                          2. Panaskan wajan anti lengket di atas api sedang. Masak tahu hingga berwarna kecokelatan di kedua sisinya. Angkat, sisihkan..
                        </li>
                        <li className="m-8">
                          3. Pada wajan yang sama, masukkan bumbu perendam dan panaskan. Masukkan jamur, aduk rata. Masukkan kailan dan kapri, masak hingga matang..
                        </li>
                        <li className="m-8">
                          4. Tata tahu di atas tumis sayuran. Sajikan segera..
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </LayoutHomepage>
    </>
  );
};

export default TumisTahu;
